import { Toast } from "@shopify/app-bridge-react"
import { Stack, TextField } from "@shopify/polaris"
import React, { Component } from "react"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import ColorSettings from "../../components/ColorSettings"
import Preloader from "../../components/WishlistApp/Preloader"
import axios from "../../funcs/axios"
import Actions from "./../../actions"
import "./styles.scss"
type State = {
    app_settings: Object,
    wishlist_settings_edited: Array<Object>,
    compare_settings_edited: Array<Object>,
    general_settings_edited: Array<Object>,
    saveState: Boolean,
    appWaiting: Boolean,
    errorValidate: Object,
    // Predifined Icons Set
    iconsSet: Object,
}

function mapStateToProps(state) {
    return {
        pages: state.pages,
        app_settings: state.app_settings,
        widgets: state.widgets,
        app_render: state.app_render,
        layout_mail: state.layout_mail,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Actions, dispatch),
    }
}

class BiSLeftLayout extends Component {
    constructor(props) {
        super(props)
        // INITIAL_STATE.app_settings = props.app_settings;
        // this.state = Object.assign({}, INITIAL_STATE);
        this.searchTimeout = null
    }

    state = {
        app_settings: JSON.parse(JSON.stringify(this.props.app_render)),
        tabSelected: 0,
        layoutTabs: [],
        layoutTabsShowWl: [
            {
                label: "Launch Show Layout",
                show: true,
            },
        ],
        appWaiting: false,
        toast: {
            error: false,
            content: "",
            show: false,
        },
        isLoading: false,
        pointTypeSetting: {
            type: "floating",
            placement: [
                { label: "Bottom Right", value: "Bottom Right" },
                { label: "Bottom Left", value: "Bottom Left" },
                { label: "Right", value: "Right" },
                { label: "Left", value: "Left" },
            ],
        },
        layoutButton: JSON.parse(JSON.stringify(this.props.layout_mail.button)),
        colorsTabs: [
            {
                label: "Show Button",
                show: true,
            },
            {
                label: "Add Button",
                show: true,
            },
        ],
    }

    componentDidMount() {
        const { layoutTabsShowWl } = this.state
        // this.props.onRef(this);
        this.setState({ layoutTabs: layoutTabsShowWl })
    }

    renderTabComponent = () => {
        const { tabSelected } = this.state

        switch (tabSelected) {
            case 0:
                return this.renderLayout()

            // case 1:
            //     return this.renderColors()

            default:
                return this.renderLayout()
        }
    }

    renderColorsShowButton = () => {
        const { layoutButton } = this.state
        return (
            <div className="row-item-wh">
                <ColorSettings
                    text="background"
                    color={layoutButton.backgroundColor}
                    changeColor={(val) => this.handleChangeColorButton("show_bg", val)}
                />
                <ColorSettings
                    text="text"
                    color={layoutButton.color}
                    changeColor={(val) => this.handleChangeColorButton("show_text", val)}
                />
            </div>
        )
    }

    handleChangeColorButton = (name, e) => {
        if (this.searchTimeout) {
            clearTimeout(this.searchTimeout)
        }
        this.searchTimeout = setTimeout(() => {
            const { actions, layout_mail } = this.props
            const { layoutButton } = this.state
            let newWidget = Object.assign({}, layoutButton)
            let newLayout = { ...layout_mail }
            switch (name) {
                case "show_bg":
                    newWidget.backgroundColor = e
                    newLayout.button = newWidget
                    actions.changeLayoutMailAction(newLayout)
                    break
                case "show_text":
                    newWidget.color = e
                    newLayout.button = newWidget
                    actions.changeLayoutMailAction(newLayout)
                    break
                default:
                    break
            }
            this.setState({ layoutButton: newWidget })
        }, 200)
    }

    handleChangeLaunchButton = (name, val) => {
        const { actions, layout_mail } = this.props
        const { layoutButton } = this.state
        let newLayoutButton = Object.assign({}, layoutButton)
        switch (name) {
            case "text":
                newLayoutButton.text = val
                this.setState({ layoutButton: newLayoutButton })
                break
            case "radius":
                newLayoutButton.borderRadius = val
                this.setState({ layoutButton: newLayoutButton })
                break
            case "fontSize":
                newLayoutButton.fontSize = val
                this.setState({ layoutButton: newLayoutButton })
                break
            case "padding":
                newLayoutButton.padding = val
                this.setState({ layoutButton: newLayoutButton })
                break
            case "subject":
                newLayoutButton.subject = val
                this.setState({ layoutButton: newLayoutButton })
                break
            default:
                break
        }
        let newLayout = { ...layout_mail }
        newLayout.button = newLayoutButton
        actions.changeLayoutMailAction(newLayout)
    }

    renderLayoutLaunchShowButton = () => {
        const { app_settings, layoutButton } = this.state
        return (
            <div>
                <div className="yta-form-group">
                    <div className="yta-label">SEND MAIL LAYOUT</div>
                    <div className="mt-2rem">
                        <TextField
                            label={"Set text of Subject"}
                            value={layoutButton.subject}
                            onChange={(val) => {
                                this.handleChangeLaunchButton("subject", val)
                            }}
                        />
                    </div>
                    <div className="btn-group">
                        <Stack vertical>
                            <Stack.Item>
                                <div className="mt-2rem">
                                    <TextField
                                        label={"Set text for button"}
                                        value={layoutButton.text}
                                        onChange={(val) => {
                                            this.handleChangeLaunchButton("text", val)
                                        }}
                                    />
                                </div>
                                <div className="mt-2rem">
                                    <TextField
                                        label={"Set button border radius"}
                                        type="number"
                                        min={3}
                                        value={layoutButton.borderRadius}
                                        onChange={(val) => {
                                            this.handleChangeLaunchButton("radius", val)
                                        }}
                                    />
                                </div>
                                <div className="mt-2rem">
                                    <TextField
                                        type="number"
                                        label={"Set button font size"}
                                        value={layoutButton.fontSize}
                                        onChange={(val) => {
                                            this.handleChangeLaunchButton("fontSize", val)
                                        }}
                                    />
                                </div>
                                <div className="mt-2rem">
                                    <TextField
                                        type="number"
                                        label={"Set button padding"}
                                        value={layoutButton.padding}
                                        onChange={(val) => {
                                            this.handleChangeLaunchButton("padding", val)
                                        }}
                                    />
                                </div>
                            </Stack.Item>
                        </Stack>
                    </div>
                    <div className="mt-2rem">{this.renderColorsShowButton()}</div>
                </div>
            </div>
        )
    }

    appProxyChange(val) {
        this.setState({
            app_settings: {
                ...this.state.app_settings,
                wishlist_settings: {
                    ...this.state.app_settings.wishlist_settings,
                    wishlist_layout: val,
                },
            },
        })
        // Cache edited setting
        this.cacheSetting("wishlist", { wishlist_layout: val })
    }

    _renderLayoutItem = (layoutTabs, item, index) => {
        return (
            <div key={index}>
                <div
                    className="btn-collapse"
                    onClick={() => {
                        let newLayoutTabs = [...layoutTabs]
                        for (let i = 0; i < newLayoutTabs.length; i++) {
                            if (i !== index) {
                                newLayoutTabs[i].show = false
                            } else {
                                newLayoutTabs[i].show = !layoutTabs[i].show
                            }
                        }
                        this.setState({ layoutTabs: newLayoutTabs })
                    }}
                >
                    <span>{item.label}</span>
                    <div className={layoutTabs[index].show ? "icon icon-down" : "icon"} />
                </div>

                <div className="collapse-block">
                    {Boolean(layoutTabs[index].show) && this.renderLayoutLaunchShowButton()}
                </div>
            </div>
        )
    }

    saveMailLayout = () => {
        axios
            .post(`${window.SHOPIFY_APP_HOST}/admin/save-config-send-mail`, this.props.layout_mail)
            .then((response) => {
                this.setState({
                    toast: { show: true, content: response.data.msg, error: false },
                })
            })
    }

    renderLayout = () => {
        const { layoutTabs, app_settings } = this.state
        return (
            <div className="layout">
                {layoutTabs.map((item, index) => this._renderLayoutItem(layoutTabs, item, index))}
            </div>
        )
    }

    render() {
        const { goBack, widgets, layout_mail } = this.props
        const { tabSelected, isLoading, toast } = this.state
        const tabs = ["Layout"]
        return (
            <div className="template-custom">
                {isLoading && <Preloader />}

                <div className="tabs-show">
                    {tabs.map((item, index) => (
                        <div
                            key={index}
                            className={tabSelected === index ? "tab tab-selected" : "tab"}
                            onClick={() =>
                                index !== tabSelected ? this.setState({ tabSelected: index }) : null
                            }
                        >
                            <div className="tab-body">{item}</div>
                        </div>
                    ))}
                </div>

                <div className="template-custom-body">{this.renderTabComponent()}</div>

                <div
                    className="yta-btn-save"
                    onClick={() => {
                        this.saveMailLayout()
                    }}
                >
                    Save
                </div>
                <div
                    className="yta-btn-back"
                    onClick={() => {
                        window.scrollTo(0, widgets.length > 1 ? 500 : 750)
                        goBack()
                    }}
                >
                    Back
                </div>

                {toast.show && (
                    <Toast
                        content={toast.content}
                        error={toast.error}
                        onDismiss={() =>
                            this.setState({
                                toast: { show: false, content: "", error: false },
                            })
                        }
                    />
                )}
            </div>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(BiSLeftLayout)
